import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";
import { BASEURL } from "../constants/baseUrl";
import "./Connexion.css";
import COLORS from "../constants/colors";

function Connexion() {
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const { setToken } = useAuth();
  const navigate = useNavigate();

  const onClick = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${BASEURL}/api/auth/login`, {
        email: login,
        password: pass,
      });

      if (res.data.token) {
        setToken(res.data.token);
        navigate("/CreateWork"); // navigation automatique
      }
    } catch (err: any) {
      alert(err.response?.data?.message || "Erreur connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
   <div
      className="connexion-container"
      style={
        {
          "--primary": COLORS.secondary,
          "--secondary": COLORS.primary,
          "--secondary-hover": COLORS.primary_hover,
        } as React.CSSProperties
      }
    >
      <h2>CONNEXION</h2>
      <input
        placeholder="Login"
        value={login}
        onChange={(e) => setLogin(e.target.value)}
      />
      <input
        type="password"
        placeholder="Mot de passe"
        value={pass}
        onChange={(e) => setPass(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onClick()}
      />
      <button className="conn_btn" onClick={onClick} disabled={loading}>
        {loading ? "Connexion..." : "ME CONNECTER"}
      </button>
    </div>
  );
}

export default Connexion;
